import React from "react";
import styled from "styled-components";
import { Localize } from "../../../locale/localization";
import TagList from "../../common/components/app/TagList";
import colors from "../../../utils/colors";

const Container = styled.div`
  margin: 1rem auto;
  p {
    font-size: 1rem;
    margin-bottom: 1em;
    color: ${colors.GRAY};
  }
`;

const TagWrap = styled.div`
  display: flex;
  align-items: flex-start;
`;

const ContentTags = props => {
  return (
    <Container>
      <p>{Localize("filters.tags")}</p>

      <TagWrap>
        <TagList
          gray
          items={props.items.slice(0, props.items.length / 3)}
          onChange={props.onChange}
        />
        <TagList
          gray
          items={props.items.slice(props.items.length / 3, props.items.length / 3 * 2)}
          onChange={props.onChange}
        />
        <TagList
          gray
          items={props.items.slice(props.items.length / 3 * 2, props.items.length)}
          onChange={props.onChange}
        />
      </TagWrap>
    </Container>
  );
};

export default ContentTags;



// WEBPACK FOOTER //
// ./src/modules/content/components/ContentTags.js